export const NAV_LINKS = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Services', path: '/services' },
  { name: 'Projects', path: '/projects' },
  { name: 'Contact', path: '/contact' }
];

export const SERVICES = [
  {
    title: "Web Development",
    description: "Custom websites and web applications built with modern technologies and best practices.",
    icon: "fas fa-code"
  },
  {
    title: "App Development",
    description: "Native and cross-platform mobile applications for iOS and Android with robust backend integration.",
    icon: "fas fa-mobile-alt"
  },
  {
    title: "Game Development",
    description: "Immersive 2D and 3D game development using Unity and Unreal Engine.",
    icon: "fas fa-gamepad"
  },
  {
    title: "Digital Marketing",
    description: "Comprehensive digital marketing strategies Including SEO, social media, and PPC campaigns.",
    icon: "fas fa-chart-line"
  },
  {
    title: "IT Solutions",
    description: "End-to-end IT infrastructure, cloud migration, cybersecurity, and 24/7 technical support.",
    icon: "fas fa-server"
  }
];

export const PROJECTS = [
  {
    title: "Vanguard Estates",
    category: "WEB DEVELOPMENT",
    description: "Luxury Real Estate Platform",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2670&auto=format&fit=crop",
    span: 2
  },
  {
    title: "HealthSync Telemed",
    category: "APP DEVELOPMENT",
    description: "Cross-platform iOS & Android App",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?q=80&w=2670&auto=format&fit=crop",
    span: 1
  },
  {
    title: "Cyber Odyssey RPG",
    category: "GAME DEV",
    description: "Unity 3D Engine",
    image: "https://images.unsplash.com/photo-1552820728-8b83bb6b773f?q=80&w=2670&auto=format&fit=crop",
    span: 1
  },
  {
    title: "Urban Trends SEO",
    category: "MARKETING",
    description: "+200% Growth Campaign",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2426&auto=format&fit=crop",
    span: 1
  }
];

export const TESTIMONIALS = [
  {
    name: "Aarav Patel",
    role: "CTO @ FinTech India",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=200&auto=format&fit=crop",
    quote: "\"Dylora transformed our chaotic legacy system into a sleek, high-performance web platform. Their understanding of backend architecture is unmatched.\"",
    rating: "★★★★★"
  },
  {
    name: "Priya Sharma",
    role: "Founder, Zen Ecommerce",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop",
    quote: "\"The app development team didn't just code; they consulted. They anticipated user behaviors we hadn't considered. Our retention rate increased by 40%.\"",
    rating: "★★★★★"
  },
  {
    name: "Rohan Mehta",
    role: "Director, Vibe",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200&auto=format&fit=crop",
    quote: "\"From the 3D assets to the SEO strategy, Dylora operates on a different level. They delivered a digital marketing campaign that went viral within 48 hours.\"",
    rating: "★★★★★"
  }
];

export const FEATURES = [
  {
    icon: "fas fa-bolt",
    title: "Fast Delivery",
    description: "Quick turnaround times without compromising quality."
  },
  {
    icon: "fas fa-shield-alt",
    title: "Secure Solutions",
    description: "Enterprise-grade security for all your applications."
  },
  {
    icon: "fas fa-sync",
    title: "Continuous Support",
    description: "24/7 monitoring and maintenance services."
  },
  {
    icon: "fas fa-chart-line",
    title: "Growth Focused",
    description: "Solutions designed to scale with your business."
  }
];

export const TECH_STACK = [
  "React / Next.js",
  "Node.js / Python", 
  "Flutter / Swift",
  "Three.js",
  "Unity / Unreal",
  "MongoDB",
  "TypeScript",
  "WebGL"
];

export const STATS = [
  { label: "SATISFACTION", value: "98%" },
  { label: "CLIENTS", value: "10+" },
  { label: "EXP", value: "2Y+" },
  { label: "SUPPORT", value: "24/7" }
];

export const SOCIAL_LINKS = [
  { name: "Instagram", url: "#" },
  { name: "LinkedIn", url: "#" },
  { name: "Twitter", url: "#" }
];

export const COMPANY_INFO = {
  name: "DYLORA",
  email: "contact@dylora.in",
  address: "Shell Colony, Chembur Mumbai-400071",
  hours: "Mon-Fri: 9:00 AM - 6:00 PM"
};